import { render, staticRenderFns } from "./multilingualContent.vue?vue&type=template&id=287739be&scoped=true&"
import script from "./multilingualContent.vue?vue&type=script&lang=ts&"
export * from "./multilingualContent.vue?vue&type=script&lang=ts&"
import style0 from "./multilingualContent.vue?vue&type=style&index=0&id=287739be&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "287739be",
  null
  
)

export default component.exports